
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class DashboardUserDialog extends Serenity.EntityDialog<DashboardUserRow, any> {
        protected getFormKey() { return DashboardUserForm.formKey; }
        protected getIdProperty() { return DashboardUserRow.idProperty; }
        protected getLocalTextPrefix() { return DashboardUserRow.localTextPrefix; }
        protected getNameProperty() { return DashboardUserRow.nameProperty; }
        protected getService() { return DashboardUserService.baseUrl; }
        protected getDeletePermission() { return DashboardUserRow.deletePermission; }
        protected getInsertPermission() { return DashboardUserRow.insertPermission; }
        protected getUpdatePermission() { return DashboardUserRow.updatePermission; }

        protected form = new DashboardUserForm(this.idPrefix);

    }
}